/**
 * Icons from google icons
 * see: https://material.io/resources/icons/
 */
module.exports = category => {
	switch (category) {
		// Community Categories
		case 'Clubs and Community Organisations':
			return 'icon icon-domain';
		case 'Cultural Groups':
			return 'icon icon-group_work';
		case 'Neighbourhood Associations':
			return 'icon icon-home';
		case 'Other Affiliations':
			return 'icon icon-people';
		case 'Places of Worship':
			return 'icon icon-import_contacts';
		case 'Schools, Colleges and Universities':
			return 'icon icon-school';
		case 'Social Enterprise, Business and Industry':
			return 'icon icon-business_center';

		// Provider categories
		case 'Animals and Pet Care':
			return 'icon icon-pets';
		case 'Agriculture':
			return 'icon icon-wb_sunny';
		case 'Tourism & Travel':
			return 'icon icon-flight';
		case 'Automotive and Engineering':
			return 'icon icon-time_to_leave';
		case 'Business and Legal':
			return 'icon icon-account_balance';
		case 'Community and Events':
			return 'icon icon-insert_invitation';
		case 'Construction and Development':
			return 'icon icon-domain';
		case 'Creative Arts':
			return 'icon icon-palette';
		case 'Education':
			return 'icon icon-school';
		case 'Fashion and Beauty':
			return 'icon icon-face';
		case 'Finance and Insurance':
			return 'icon icon-attach_money';
		case 'Food and Nutrition':
			return 'icon icon-restaurant';
		case 'Gardening and Landscaping':
			return 'icon icon-nature';
		case 'Health Care and Fitness':
			return 'icon icon-fitness_center';
		case 'Lifestyle':
			return 'icon icon-golf_course';
		case 'Marketing and Communications':
			return 'icon icon-chat_bubble';
		case 'Music and Entertainment':
			return 'icon icon-audiotrack';
		case 'Photography':
			return 'icon icon-photo_camera';
		case 'Real estate':
			return 'icon icon-home';
		case 'Religious':
			return 'icon icon-import_contacts';
		case 'Research and Development':
			return 'icon icon-bubble_chart';
		case 'Sport and Recreation':
			return 'icon icon-directions_run';
		case 'Technology and Design':
			return 'icon icon-memory';
		case 'Trades':
			return 'icon icon-build';
		case 'Training and Development':
			return 'icon icon-supervisor_account';
		case 'Writing and Publishing':
			return 'icon icon-class';
		case 'Retail':
			return 'icon icon-shopping_cart';
		case 'Hospitality':
			return 'icon icon-local_hotel';
		case 'Coaching and Mentoring':
			return 'icon icon-assistant';
		default:
			return 'icon icon-view_headline';
	}
};



// WEBPACK FOOTER //
// ./src/search/CategoryIconPicker.js